import { Card } from 'antd'
import { INBOX_DARK_BACKGROUND } from 'features/inbox/colors'
import { ASSET_COLORS } from 'features/inbox/components/inspectionCards/utils'
import { InspectionOverviewContent } from 'features/inbox/components/shared/InspectionOverviewContent'
import { EnrichedGeckoInspection } from 'features/inbox/types/types'
import React, { memo } from 'react'
import styled from 'styled-components'
import CantileverTheme from 'styles/cantileverTheme'

const StyledInspectionCard = styled(Card)<{ $selected: boolean }>`
  cursor: pointer;
  transition: all 0.15s ease;
  background: ${INBOX_DARK_BACKGROUND};
  border: ${(props) =>
    props.$selected
      ? `2px solid ${CantileverTheme.colors.alternate['400']}`
      : 'none'};

  &:hover {
    background: rgba(70, 70, 70, 1);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.4);
    transform: translateY(-2px);
  }

  .ant-card-body {
    padding: 1rem;
  }
`

interface InspectionCardProps {
  inspection: EnrichedGeckoInspection
  isSelected: boolean
  unitColors: Record<string, string>
  onCardClick: (inspectionId: string) => void
}

const InspectionCardBase: React.FC<InspectionCardProps> = ({
  inspection,
  isSelected,
  unitColors,
  onCardClick,
}) => {
  const unitColor = unitColors[inspection.tags.unit] || ASSET_COLORS[0]

  return (
    <StyledInspectionCard
      key={inspection.id}
      $selected={isSelected}
      onClick={() => onCardClick(inspection.id)}
      role='button'
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault()
          onCardClick(inspection.id)
        }
      }}
      aria-label={`Select inspection ${(inspection.data?.name as string) || inspection.id}`}
      size='small'>
      <InspectionOverviewContent
        inspection={inspection}
        unitColor={unitColor}
        withMetricsMargin
      />
    </StyledInspectionCard>
  )
}

export const InspectionCard = memo(InspectionCardBase)
